var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

export { getOppositeVariationPlacement as g };
//# sourceMappingURL=getOppositeVariationPlacement-92cf43cc.js.map
